import {DeviceOs} from './device-os';

export const DISTRIBUTION_LINKS = {
  [DeviceOs.Ios]: 'https://apps.apple.com/nl/app/bruiloft-in-je-broekzak/id1242502508',
  [DeviceOs.Android]: 'https://play.google.com/store/apps/details?id=nl.tbraak.bruiloftinjebroekzak'
};
